export const EMPLOYEE_DELETE = "EMPLOYEE_DELETE";
export const TYPE_ADD_EMPLOYEE = 'TYPE_ADD_EMPLOYEE';
export const GET_EMPLOYEE_LIST = 'GET_EMPLOYEE_LIST';
export const GET_EMPLOYEE_DETAILS="GET_EMPLOYEE_DETAILS";
export const UPDATE_EMPLOYEE_DETAILS="UPDATE_EMPLOYEE_DETAILS";
export const GET_CALL_UASGE_LIST="GET_CALL_UASGE_LIST";
export const GET_ROLE_ACCESS_LIST="GET_ROLE_ACCESS_LIST";
export const GET_SAVE_AND_EDIT_DATA="GET_SAVE_AND_EDIT_DATA";
export const GET_SIDEMENU_DETAILS = 'GET_SIDEMENU_DETAILS';
export const GET_MEMBER_RECENT_CHAT = 'GET_MEMBER_RECENT_CHAT';
export const GET_MEMBER_CHAT_HISTORY = 'GET_MEMBER_CHAT_HISTORY';
export const CHAT_MEDIA_DOWNLOAD = 'CHAT_MEDIA_DOWNLOAD';
